import { Directive, ElementRef, Input, OnInit, OnDestroy } from '@angular/core';
import { CurrencyService } from '../services/currency.service';
import { Region } from '../interfaces/region.interface';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appTextDirection]',
  standalone: true
})
export class TextDirectionDirective implements OnInit, OnDestroy {
  @Input() appTextDirection?: Region | string;

  private subscription = new Subscription();

  constructor(
    private el: ElementRef,
    private currencyService: CurrencyService
  ) {}

  ngOnInit(): void {
    if (this.appTextDirection && typeof this.appTextDirection === 'object') {
      // Use the provided region
      this.setDirection(this.appTextDirection);
    } else {
      // Subscribe to current region changes
      this.subscription.add(
        this.currencyService.currentRegion$.subscribe(region => {
          if (region) {
            this.setDirection(region);
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  private setDirection(region: Region): void {
    const direction = region.text_direction;
    this.el.nativeElement.setAttribute('dir', direction);

    // Add CSS class for additional styling if needed
    this.el.nativeElement.classList.remove('rtl', 'ltr');
    this.el.nativeElement.classList.add(direction);
  }
}
